/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrdersStakeholderQuery } from '../../models/get-orders-stakeholder-query';
import { GetOrdersStakeholderQueryResult } from '../../models/get-orders-stakeholder-query-result';

export interface ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain$Params {
      body?: GetOrdersStakeholderQuery
}

export function apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersStakeholderQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrdersStakeholderQueryResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderGetOrdersStakeholderPost$Plain.PATH = '/api/NurseryManager/OrderStakeholder/GetOrdersStakeholder';
